import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useCreateInvoice } from '~/api/invoices';
import { useUser } from '~/api/user';
import { Button } from '~/components';
import { r, routes } from '~/providers/RouterProvider/router.routes';
import { toast } from '~/utils/toast';
import { isAccountCompleted } from '~/utils/user';

import { ctaStyle, ctaTitleStyle } from './ChartCta.css';

export const ChartCta = () => {
  const { t } = useTranslation(['dashboard', 'common']);
  const { data: user } = useUser();
  const createDraftInvoiceMutation = useCreateInvoice();
  const navigate = useNavigate();

  const createDraftInvoice = () => {
    if (createDraftInvoiceMutation.isPending) return;

    createDraftInvoiceMutation.mutate(undefined, {
      onSuccess: ({ id }) => navigate(r(routes.createInvoice, { invoiceId: id })),
      onError: () => toast.danger({ description: t('common:error') }),
    });
  };

  return (
    <div className={ctaStyle}>
      <p className={ctaTitleStyle}>{t('dashboard:charts.cta.title')}</p>

      <p>{t('dashboard:charts.cta.text')}</p>

      {isAccountCompleted(user) && (
        <Button icon="Add" loading={createDraftInvoiceMutation.isPending} onClick={createDraftInvoice}>
          {t('dashboard:charts.cta.createInvoice')}
        </Button>
      )}
    </div>
  );
};
